import * as React from 'react';

import * as style from './style.css';

export const Layout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={style['container']}>{children}</div>;
};
